import React,{useState,memo,useEffect} from 'react';
import { getUserAuthorities,getCurrentModuleId,getUserInfo,getDefaultModule } from '../../../Utils/UserFunctions';
import {isSet} from '../../../Utils/CommonFunctions';
import Icons from "../../Icons/Icons";
import $ from 'jquery';

const TopNav = props => {
	const userAuthorities = getUserAuthorities();
	const currentModuleId = getCurrentModuleId();
	// console.log(getCurrentModuleId());
	// const userInfo = getUserInfo();
	// console.log('-------',currentModuleId,'------',getDefaultModule());
	let userDefaultMod = '';
	/*if(userInfo && userInfo.data && userInfo.data.user_preference && userInfo.data.user_preference.default_module) {
		userDefaultMod = userInfo.data.user_preference.default_module;
	}
	console.log(userDefaultMod);*/

	/*useEffect(() => {
		window.addEventListener('click', testt);
	}, []);*/
	const [agreed,setAgreed] = useState(false);


	/*const testt = (e) => {
		e.stopPropagation();
		console.log('testst')
	}*/

	const defaultModuleHandler = (checked,modId, modName) => {
		// console.log('ddddddddddd',!agreed)

		// setAgreed(!agreed);
		moduleChangeHandler(modId,modName)
		// e.stopPropagation();
		// console.log('testst')
	}

	const leftMenuGenerate = (modId, modName) => {
		setAgreed(false);
		if(getDefaultModule()!== modId && getDefaultModule()!== modName ) {
			$('#changeClassIde').removeClass('selected');
		}
		props.leftMenuGenerate(modId,modName);
	}

	const moduleChangeHandler = (modId, modName) => {
		console.log("modId, modName",modId, modName);
		// setDefaultModuleId(modId);
		setAgreed(false);
		$('#changeClassIde').addClass('selected');
		props.changeModuleHandler(modId,modName)
	}

	let userModule = '';
	userModule = (userAuthorities != null && userAuthorities.data) ? isSet(userAuthorities.data,[]).map((arr,i) => {
			if(arr.id === currentModuleId)
			{
				userDefaultMod = arr.module_name;
			}
				return(
					<li className="product-list" key={i} moduleid={arr.id} onClick={() => leftMenuGenerate(arr.id,arr.module_name)}>
						<a className={userDefaultMod === arr.module_name ? "cursor-pointer selected" : "cursor-pointer"  }>
							<div className="navi-link">
								<div className="mr-3">
									<span className="">
										<Icons iconType={arr.module_name} />
									</span>
								
								</div>
								<div className="navi-text">
									<div className="">{arr.module_name}</div>
									
									<div className="fourth_dark_color text-small">{isSet(arr.description,'Lorem ipsum dolor sit amet, consectetur adipiscing elit.')} 
									</div>
								</div>
								{userDefaultMod === arr.module_name &&
								<>
								<i className="fas fa-check-circle productSelected fa-lg text-success"></i>
															</>
								}
							</div>
							{userDefaultMod === arr.module_name &&
							<div className="custom-control custom-checkbox mr-0" style={{background:'#f7f7f7', textAlign:'right',padding:'5px',borderBottomLeftRadius:'5px',borderBottomRightRadius:'5px'}}>
									<input type="checkbox" className="custom-control-input" disabled={getDefaultModule() && getDefaultModule() === userDefaultMod ? true : false} id="agree" name="agree" onChange={(e)=>defaultModuleHandler(e.target.checked,currentModuleId,userDefaultMod)} checked={getDefaultModule() && getDefaultModule() === userDefaultMod ? true : agreed} />
									<label className="custom-control-label  pr-2" htmlFor="agree"> Set as default view </label>

									{/* <button onClick={() => moduleChangeHandler(currentModuleId,userDefaultMod)} type="button" className="btn primary_bg btn-xs" disabled={getDefaultModule() && getDefaultModule() === userDefaultMod ? true : !agreed}> Apply </button> */}
								</div>	
							}
						</a> 
					</li>
				);
			}) : '';
	if(isSet(userDefaultMod,null)===null){
		userDefaultMod = getDefaultModule();
	}

	return (
		<ul className={(props.isMobileView===true)?"navbar-nav topbar-nav":"navbar-nav topbar-nav d-none d-lg-block"}> 
			<li className="nav-item focus dropdown hidden-caret svgIconFill">
				<a className="nav-link cursor-pointer topModule" data-toggle="dropdown" aria-expanded="false" style={{backgroundColor:'#ff6b32'}}>
					<Icons iconType="IconDots" /> {/*<span className="text-small"> {userDefaultMod} </span>*/}
				</a>
				 <ul className="dropdown-menu dropnotHide notif-box  product-box" aria-labelledby="" style={{minWidth:'30rem', borderRadius:'10px'}}>
					{userModule}
				</ul>
				<div className="selectgroup moduleSelect">
					<div id="changeClassIde" className={getDefaultModule() && getDefaultModule() === userDefaultMod ? "selectgroup-item selected" : "selectgroup-item" }>{/*selected*/} 
						<label className="selectgroup-button cursorText">
							{userDefaultMod}
							<i className="pl-1 fas fa-check-circle" style={{color:'#0f9d58'}}></i>
					 	</label>
						
					</div>
					{/* <div className="selectgroup-item" >
						<label className="selectgroup-button selectgroup-button-icon" data-toggle="dropdown" aria-expanded="true">
							<i className="fas fa-ellipsis-v"></i>
							
						</label>
						<div className="dropdown-menu dropnotHide">
							 <div className="custom-control custom-checkbox mr-0">
								<input type="checkbox" className="custom-control-input" id="agree" name="agree" onChange={defaultModuleHandler} checked={getDefaultModule() && getDefaultModule() === userDefaultMod ? true : agreed} />
								<label className="custom-control-label text-small pr-2" htmlFor="agree"> Save as default view </label>

								<button onClick={() => moduleChangeHandler(currentModuleId,userDefaultMod)} type="button" className="btn primary_bg btn-xs" disabled={getDefaultModule() && getDefaultModule() === userDefaultMod ? true : !agreed}> Apply </button>
							</div>
						</div>
					</div> */}
					
				</div>
			</li> 
		</ul>
	);
};

export default TopNav;